__webpack_require__.p = "/Passcodes-Website/_next/";